import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  rusclicked = false;
  title = 'Premier Field Employee Application';

  //md test
  ////////////////////////////////////
  isDropdownOpen = false;
  selectedFlag: string | null = null;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  selectFlag(flag: string) {
    this.selectedFlag = flag;
    this.isDropdownOpen = false;
  }
  ///////////////////////////////////////////

  constructor(public translate: TranslateService) {
   // translate.addLangs([]);  //'en', 'nl','es','de'
    //translate.setDefaultLang('');//en
    translate.setDefaultLang('en');
  }
  switchLang(lang: string) {
    this.translate.use(lang);
  }

  //md add

  switchLanguage(language: string) {

    console.log('lang', language);
  
    if (language === 'ru') {
      this.rusclicked = true;
      console.log('reached');
    } else {
      this.rusclicked = false;
      console.log('reached1');
    }
  
  
    this.translate.use(language);
  }
  
}
